import VSLRow from "./VSLRow";

export default class VSLHtmlRow extends VSLRow {

    constructor(id, label = null, value = null) {
        super(id, "html");

        this.label = label;
        this.value = value;
    }
}